import React, { Component } from 'react';
import {Switch, Route} from 'react-router-dom';
import Layout from './hoc/layout';
import Home from './components/home/home';
import Dashboard from './components/dashboard/dashboard';
import AddRobot from './components/dashboard/addrobot';
import AddManufacturer from './components/dashboard/addmanufacturer';
import RobotList from './components/dashboard/robots_list';
import ManufacturersList from './components/dashboard/manufacturers_list';
import AboutUs from './components/aboutus.js' ;
import AccessDenied from './components/access_denied';

class Routes extends Component {
    render() {
        let {user} = this.props;
        return (
            <Layout user={user}>
                <Switch>
                    <Route path="/" user={user} exact component={Home} />
                    
                    <Route path="/about-us" exact component={AboutUs} />

                    <Route path="/robots-list" exact component={(props)=>{
                        return <RobotList user={user} />
                    }} />

                    <Route path="/edit-bot/:id" exact component={(props)=>{
                        if(user){
                            return <AddRobot user={user} robot_id={props.match.params.id} />
                        }else{
                            return <AccessDenied/>;
                        }
                    }} />

                    <Route path="/manufacturers-list" exact component={(props)=>{
                        return <ManufacturersList user={user} />
                    }} />

                    <Route path="/edit-manufacturer/:id" exact component={(props)=>{
                        if(user){
                            return <AddManufacturer user={user} {...props} />
                        }else{
                            return <AccessDenied/>;
                        }
                    }} />

                    <Route path="/dashboard" exact component={(props)=>{
                        return <Dashboard user={user} />
                    }} />

                    <Route path="/add-robot" exact component={(props)=>{
                        if(user){
                        return <AddRobot user={user} />
                        }else{
                            return <AccessDenied/>;
                        }
                    }} />

                    <Route path="/add-manufacturer" exact component={(props)=>{
                        if(user){
                        return <AddManufacturer user={user} />
                        }else{
                            return <AccessDenied/>;
                        }
                    }} />
                </Switch>
            </Layout>
        );
    }
}

export default Routes;


// WEBPACK FOOTER //
// ./src/routes.js